//
//
//
//
//
//
//
//
//

import Api from './api/pay'
import { mapState } from 'vuex'
export default {
  name: 'app',
  mounted () {
    this.rem()
  },
  computed: {
    ...mapState({
      appType: state => state.payParams.appType,
    })
  },
  watch: {
    '$route': function (to) {
      if(this.appType=='alipay'){
        if(to.name=='pay'|| to.name=='scanQrcPay'|| to.name=='chargeMoney'||to.name=='unlicensedQroNew'){
          let auth_code=to.query.auth_code
          if(auth_code){
            sessionStorage.setItem('auth_code', 1)
            let param={
              code:auth_code,
            }
            // alert(auth_code)
            // alert(JSON.stringify(param))
            Api.aliUserInfo(JSON.stringify(param)).then(res => {
              // alert(res.data.openId)
              // console.log("支付宝请求数据res",res)
              let data=res.data
              let openId=data.openId
              this.$store.commit('payParams/getOpenId', openId)
            }).catch(err => {
              // alert(JSON.stringify(err))
              console.log("err",err)
            })
          }
        }
      }
    }
  },
  methods: {
    rem () {
      (function (win, doc) {
        // 设计稿宽度750px，浏览器iphone8宽度是375px，1rem=100px，所以设置基数为 2*100
        function change () {
          doc.documentElement.style.fontSize = doc.documentElement.clientWidth / 375 * 100 + 'px'
        }
        change()
        win.addEventListener('resize', change, false)
        win.addEventListener('orientationchange', change, false) // 横纵向旋转
      })(window, document)
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue